import Vue from 'vue';
import VueRouter from 'vue-router';
import baseLayout from '@/layout';
import mobileLayout from '@/mobileLayout';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'web',
    redirect: '/home',
    component: baseLayout,
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          webRoute: '/home',
          mobileRoute: '/mobile/wap',
        },
        component: () =>
            import(/* webpackChunkName: "home" */ '@/views/web/home'),
      },
      {
        path: 'list',
        name: 'list',
        meta: {
          webRoute: '/list',
          mobileRoute: '/mobile/wap-list',
        },
        component: () =>
            import(/* webpackChunkName: "list" */ '@/views/web/newList'),
      },
      {
        path: 'detail',
        name: 'detail',
        meta: {
          webRoute: '/detail',
          mobileRoute: '/mobile/wap-detail',
        },
        component: () =>
            import(/* webpackChunkName: "detail" */ '@/views/web/newDetail'),
      },
    ],
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: mobileLayout,
    children: [
      {
        path: 'wap',
        name: 'wap',
        meta: {
          webRoute: '/home',
          mobileRoute: '/mobile/wap',
        },
        component: () =>
            import(/* webpackChunkName: "wap" */ '@/views/wap/home'),
      },
      {
        path: 'wap-list',
        name: 'wap-list',
        meta: {
          webRoute: '/list',
          mobileRoute: '/mobile/wap-list',
        },
        component: () =>
            import(/* webpackChunkName: "wap-list" */ '@/views/wap/newList'),
      },
      {
        path: 'wap-detail',
        name: 'wap-detail',
        meta: {
          webRoute: '/detail',
          mobileRoute: '/mobile/wap-detail',
        },
        component: () =>
            import(/* webpackChunkName: "wap-detail" */ '@/views/wap/newDetail'),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const baseTiltle = '_吉林省饮食文化研究会';
  const listTitle = {
    home: '首页',
    notice: '公告通知',
    trends: '协会动态',
    rule: '竞技比赛',
    information: '行业资讯',
    elegantDemeanour: '百年吉菜',
    trainingEducation: '技能认证',
    dietaryCulture: '饮食文化',
  };
  document.title = to.query.type
      ? `${listTitle[to.query.type]}${baseTiltle}`
      : `首页${baseTiltle}`;
  if (!_isMobile() && to.path.includes('mobile')) {
    next('/home');
  } else if (_isMobile() && !to.path.includes('mobile')) {
    next('/mobile/wap');
  }
  next();
});

const _isMobile = () => {
  return window.innerWidth <= 768;
};

export default router;
